// FILECONTENT_START src/common/components/DataGrid/row-buttons/ActionButtonDelete.tsx
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import I18n from "i18n-js";
import { DataGridActionButtonProps } from "../DataGrid";
import { GridActionsCellItem } from "../grid-imports";

export default function ActionButtonDelete({
  onClick,
  onlyTrashed,
  disabled,
}: DataGridActionButtonProps) {
  return (
    <GridActionsCellItem
      icon={onlyTrashed ? <DeleteForeverIcon /> : <DeleteIcon />}
      label={I18n.t(onlyTrashed ? "App.deleteTrash" : "App.delete")}
      title={I18n.t(onlyTrashed ? "App.deleteTrash" : "App.delete")}
      onClick={() => onClick && onClick()}
      disabled={disabled}
      //color="inherit"
    />
  );
}

// FILECONTENT_END src/common/components/DataGrid/row-buttons/ActionButtonDelete.tsx